import get from 'lodash.get';
import { constants } from '@yola/subscription-manager-js';

const {
  hostingPackageFeatureNames: { PARTNER_ADS },
  SubscriptionType,
} = constants;

const brandedHeaderLimit = ({ targetPackage, userFeatures, featureFlags = {} }) => {
  // TODO: remove access to featureFlagsManager.state when after we remove this workaround
  // with feature flag inside the limit calculation
  const { remove_partner_ads: isRemovePartnerAdsEnabled } = featureFlags;
  let isRemovable =
    !targetPackage.features[PARTNER_ADS] || get(userFeatures, 'yolaHeader.removed', false);

  if (targetPackage.type === SubscriptionType.B2C_HOSTING_BRONZE && isRemovePartnerAdsEnabled) {
    isRemovable = true;
  }

  return {
    removable: isRemovable,
  };
};

export default brandedHeaderLimit;
